import { useDispatch } from "react-redux"
import { addProductToCart, removeProductFromCart } from "../../redux/cartSlice";
import { useTranslation } from "react-i18next";

const CartProductCard = ({ purchaseData }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const addOrSub = (amount) => {
        const purchaseDataObject = { ...purchaseData };
        purchaseDataObject.quantity = amount === 1 ? 1 : -1;
        dispatch(addProductToCart(purchaseDataObject));
    };
    return (
        <div className="w-full md:w-[600px] bg-gree-300 p-2 rounded-xl border border-[#225424] flex gap-4 md:gap-8">
            {/* Foto */}
            {
                purchaseData &&
                <div className="w-full flex justify-between gap-2">
                    {/* Delete add and substract */}
                    <div className="flex gap-4 items-center">
                        <button className="rounded-lg border border-neutral-300 text-[#225424] flex justify-center items-center text-xl py-2 px-4 hover:bg-[#e2eeed] gap-2" onClick={() => dispatch(removeProductFromCart(purchaseData))}><div className='pt-[5px]'><i className="fi fi-rr-trash"></i></div></button>
                        <div className="w-6 flex flex-col gap-1">
                            <div className="border w-full flex flex-col items-center justify-center cursor-pointer rounded" onClick={() => addOrSub(1)}>+</div>
                            <div className="border border-red-400 w-full flex flex-col items-center justify-center cursor-pointer rounded" onClick={() => addOrSub(-1)}>-</div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div className="text-[8px]">{t("Cart.CartProductCard.quantity")}</div>
                            <div>{purchaseData?.quantity}</div>
                        </div>
                        
                    </div>
                    {/* Product */}
                    <div className="flex gap-2 items-center justify-start flex-grow sm:ml-8">
                        <div className="min-w-12 max-w-12 h-12 overflow-hidden rounded">
                            <img src={purchaseData?.coverImageUrl} alt={purchaseData?.title || ''} className="h-full w-full object-cover" />
                        </div>
                        <div className="flex flex-nowrap flex-col">
                            <div className="font-bold text-xs">{purchaseData?.title}</div>
                            <div>{purchaseData.size}</div>
                        </div>
                    </div>
                    {/* Price */}
                    <div className="flex items-center text-2xl md:text-4xl">
                        {(purchaseData.price * purchaseData.quantity).toFixed(2)}
                    </div>
                </div>
            }
        </div>
    )
}

export default CartProductCard